import React, { lazy } from 'react';
import { FadeIn } from './ui/FadeIn';
export function WhatsAppProofSection() {
  const screenshots = [{
    src: 'https://cdn.magicpatterns.com/uploads/gnkWFFAHnhNcTzYUq1pK3k/foto_1.png',
    alt: 'Conversación con Ana'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/bxttvaN7VJEQUxqrLf1Yzd/foto_3.png',
    alt: 'Conversación con Carmen'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/kGEXQ1DEamy5vTJce7faHU/foto_2.png',
    alt: 'Conversación con Laura'
  }];
  return <section className="py-16 bg-cream-alt relative" data-id="element-251">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-252">
        <FadeIn data-id="element-253">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-center text-charcoal mb-4" data-id="element-254">
            Conversaciones reales con clientas
          </h3>
          <p className="text-center text-charcoal-muted mb-12" data-id="element-255">
            Sin filtros. Sin editar. Así nos escriben.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-256">
          {screenshots.map((screenshot, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-257">
              <div className="bg-white rounded-2xl p-3 shadow-card border border-cream-dark/40 overflow-hidden" data-id="element-258">
                <img src={screenshot.src} alt={screenshot.alt} className="w-full h-auto rounded-xl object-cover" loading="lazy" data-id="element-259" />
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}